import * as React from 'react';
import { SVGProps } from 'react';

const IconArrowUndoneSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.828 12H17.5a2.5 2.5 0 0 1 0 5H17v2h.5a4.5 4.5 0 1 0 0-9H5.828l3.586-3.586L8 5l-6 6 6 6 1.414-1.415L5.828 12Z"
    />
  </svg>
);
export default IconArrowUndoneSizeM;
